import React, { type ReactElement } from 'react';

import { CheckboxSVG } from '~/src/assets/icons';

import { useHandlerAdapter } from './checkbox.helpers';
import {
  CheckboxBox,
  CheckboxField,
  CheckboxIcon,
  CheckboxInner,
  CheckboxText,
} from './checkbox.styles';
import { CheckboxProps } from './checkbox.types';

export function Checkbox<Value extends unknown>(props: CheckboxProps<Value>): ReactElement | null {
  const {
    boxRef,
    fieldRef,
    name,
    value,
    placeholder,
    isChecked,
    isDisabled,
    isErrored,
    onChange,
    onFocus,
    onBlur,
    children,
    ...rest
  } = props;

  const onChangeHandler = useHandlerAdapter(value, onChange);
  const onFocusHandler = useHandlerAdapter(value, onFocus);
  const onBlurHandler = useHandlerAdapter(value, onBlur);

  return (
    <CheckboxBox {...rest} ref={boxRef}>
      <CheckboxField
        ref={fieldRef}
        name={name}
        type="checkbox"
        value={`${value}`}
        placeholder={placeholder}
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChangeHandler}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
      />
      <CheckboxInner>
        <CheckboxIcon>
          <CheckboxSVG />
        </CheckboxIcon>
        <CheckboxText>
          {children}
        </CheckboxText>
      </CheckboxInner>
    </CheckboxBox>
  );
}
